export default __webpack_public_path__ + "static/capitals-b7a112441b9e3c6d5289b65053311753.png";